export default "__VITE_ASSET__CjDVIHCm__"